import React from 'react'
import Box from '@material-ui/core/Box'
import AnnouncementTable from '../../../components/admin/forestage/AnnouncementTable'
import AnnouncementListToolbar from '../../../components/admin/forestage/AnnouncementListToolbar'
import ScrollablePaper from '../../../components/default/present/ScrollablePaper'
import { SearchToRequestFunc } from '../../../utils/default/ComplexFlowHook'
import { pipe, acceptUndefined, parseInt, guaranteeBetween, guaranteeBeKey } from '../../../utils/default/FormHelper'
import announcementStatusName from '../../../constants/admin/announcementStatusName'
import { AnnouncementType } from '@golden/gdk-campaign'
import announcementTypeName from '../../../constants/default/announcementTypeName'
import { isUndefined, omitBy } from '@golden/utils'

export interface RequestType {
  page: number
  status?: number
  type?: string
  content?: string
}

export const searchToRequest: SearchToRequestFunc<RequestType> = (search) => {
  const converted = {
    ...search,
    page: acceptUndefined(
      search.page,
      pipe(
        parseInt,
        (value) => guaranteeBetween(value, 1, Number.MAX_SAFE_INTEGER)
      )
    ) || 1,
    status: acceptUndefined(
      search.status,
      pipe(
        (value) => guaranteeBeKey(value, Object.keys(announcementStatusName).concat('0')),
        parseInt
      )
    ) || undefined,
    type: acceptUndefined(
      search.type,
      pipe(
        (value) => guaranteeBeKey(value, Object.keys(announcementTypeName))
      )
    ) || undefined
  }
  return omitBy(converted, isUndefined) as unknown as RequestType
}

const AnnouncementPage: React.FC = () => {
  return (
    <Box paddingY={5}>
      <ScrollablePaper marginX={4}>
        <Box padding={4}>
          <AnnouncementListToolbar />
          <Box paddingY={5}>
            <AnnouncementTable />
          </Box>
        </Box>
      </ScrollablePaper>
    </Box>
  )
}

export default React.memo(AnnouncementPage)
